"use client";

import React from "react";
import VideoComponent from "../../libs/VideoComponent";
import VideoSliderComponent from "../../libs/VideoSliderComponent";

const TarjetasComponent: React.FC = () => {
  return (
    <>
      <div className="overview-area ptb-100">
        <div className="container">
          <div className="overview-item-style-two">
            <div className="row align-items-center">
              <div
                className="col-lg-6 col-md-12 overview-image h-100"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                <VideoComponent url="https://www.youtube.com/watch?v=7ZU30Ju8eUI" />
              </div>
              <div className="col-lg-6 col-md-12 overview-content">
                <h2 className="nunito-font">Distribuidora Aliados</h2>
                <p>
                  Distribuidora Aliados, fundada en 1984, es una empresa
                  colombiana que se destaca por su excelente servicio en el
                  abastecimiento de productos químicos a nivel nacional.
                  Actualmente, es líder en el suministro de productos para el
                  tratamiento de agua y cuenta con un amplio portafolio para
                  diversos sectores de la industria química. La empresa recibe
                  altas calificaciones en servicio al cliente, cumplimiento de
                  entregas, calidad de productos y soporte técnico. Representa a
                  más de 8 fábricas colombianas y también realiza importaciones
                  de productos de Estados Unidos, India y China.
                </p>
              </div>
            </div>
          </div>

          <div className="overview-item-style-two">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 overview-content">
                <h2 className="nunito-font text-end">Políticas de calidad</h2>
                <p className="text-end">
                  Lograr la fidelidad de nuestros clientes y proveedores,
                  brindando productos y servicios confiables y competitivos,
                  mediante el aseguramiento de la calidad y el mejoramiento
                  continuo, estableciendo un sistema de gestión integral que
                  involucre la calidad en los procesos, el cuidado del medio
                  ambiente, la seguridad y la salud en el trabajo.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-12 overview-image"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                <img
                  src="/images/overview/politicas_de_calidad.webp"
                  alt="overview-image"
                  width={875}
                  height={1030}
                />
              </div>
            </div>
          </div>

          <div className="overview-item-style-two">
            <div className="row align-items-center">
              <div
                className="col-lg-6 col-md-12 overview-image"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                {/* <VideoComponent url="https://www.youtube.com/watch?v=NBKKFh-9qh4" /> */}
                <VideoSliderComponent />


              </div>
              <div className="col-lg-6 col-md-12 overview-content">
                <h2 className="nunito-font">Misión</h2>
                <p>
                  Trabajamos cada día para hacer una diferencia positiva en la
                  vida de nuestros clientes, empleados y socios, y para dejar un
                  legado sostenible para las generaciones futuras. Nuestra
                  prioridad es la satisfacción del cliente, pero también lo es
                  el bienestar de nuestra comunidad y del planeta.
                </p>
                <h2 className="nunito-font">Visión</h2>
                <p>
                  En el 2034 seremos la empresa de productos quimicos para el
                  tratamiento de agua mas respetada y admirada en la industria
                  colombiana y nuestro objetivo será la innovación la
                  sostenibilidad y el logro del éxito.
                </p>
              </div>
            </div>
          </div>

          <div className="overview-item-style-two">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 overview-content">
                <h2 className="nunito-font text-end">Nuestra promesa de valor</h2>
                <p className="text-end">
                  Con 40 años de experiencia en el sector químico y de
                  tratamiento de agua, nos comprometemos a satisfacer a nuestros
                  clientes con productos de excelente calidad, entregas
                  eficientes y un amplio portafolio de productos químicos.
                  Nuestro personal altamente capacitado está siempre listo para
                  atender oportunamente todas sus solicitudes, garantizando
                  soluciones efectivas y personalizadas para cada necesidad.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-12 overview-image"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                <img
                  src="/images/overview/nuestra_promesa_de_valor.webp"
                  alt="overview-image"
                  width={875}
                  height={1030}
                />
              </div>
            </div>
          </div>

          <div className="overview-item-style-two">
            <div className="row align-items-center">
              <div
                className="col-lg-6 col-md-12 overview-image"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                <img
                  src="/images/overview/sectores_economicos.webp"
                  alt="overview-image"
                  width={875}
                  height={852}
                />
              </div>
              <div className="col-lg-6 col-md-12 overview-content">
                <h2 className="nunito-font">Sectores económicos</h2>
                <p>
                  Las diferentes industrias deben ir de la mano del cuidado
                  responsable del medio ambiente, por tal razón el uso del agua,
                  reutilización y correcto tratamiento hace de nuestros
                  productos una excelente alternativa.
                </p>
                <p>
                  Productos con la concentración correcta, empaques etiquetados
                  con información confiable, y la posibilidad de tenerlos en el
                  menor tiempo posible hacen de DISTRIBUIDORA ALIADOS la mejor
                  opción a nivel nacional en el suministro de productos
                  químicos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TarjetasComponent;
